module.exports = __webpack_public_path__ + "static/media/salt-busd.b4c8351f.png";